import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { CircleNotch } from '@phosphor-icons/react/dist/ssr';
import { clsx } from 'clsx';
import type { FC } from 'react';

type Props = {
  size?: 'icon-s' | 'icon-m' | 'icon-l';
};

const Spinner: FC<Props> = ({ size = 'icon-s' }) => (
  <PhosphorIcon
    Icon={CircleNotch}
    className={clsx('animate-spin', size)}
    variant="regular"
    data-testid="spinner"
  />
);

export default Spinner;
